<template>
  <div>
    <div class="row goal flex-nowrap" @click="expanded = !expanded">
      <collapse-caret class="flex-shrink-0 collapse-caret" :size="23" :expanded="expanded" />
      <i class="row-item goal-icon flex-shrink-0"></i>
      <div
        class="row-item goal-title text-medium-1 bold text-truncate d-flex align-items-center"
        :title="activity.goal.title"
      >
        <span class="text-truncate" v-no-capture>{{ activity.goal.title }}</span>
        <span
          class="expander-icon pointer ml-2"
          :id="'goal-expander-' + activity.goal.id"
          @click.stop="goToGoalPage"
          ><i></i
        ></span>
        <action-tooltip :target="'goal-expander-' + activity.goal.id" text="Open" />
      </div>
    </div>
    <b-collapse v-model="expanded">
      <template v-for="(krActivity, index) in activity.keyResultGroups">
        <kr-activity
          :activity="krActivity"
          :goal="activity.goal"
          :key="'goal-' + index"
          @awarded="$emit('awarded')"
          @reacted="$emit('reacted')"
          v-if="hasActivity(krActivity) && krActivity.keyResult"
        />
      </template>
    </b-collapse>
  </div>
</template>

<script>
import CollapseCaret from '@/components/CollapseCaret'
import handleClickNavigation from '@/utils/handleClickNavigation'
import { getGoalPageRouteConfig } from '@/utils/navigationConfigs'
import { BCollapse } from 'bootstrap-vue'
import ActionTooltip from '@/components/ActionTooltip'
import KrActivity from '@/components/activity/KrActivity'

/**
 * This components shows activities on a goal. Currently we are not showing any direct activity on Goal. This shows activities on KRs/Initiatives
 */
export default {
  name: 'Activities',
  props: ['orgId', 'activity'],
  components: {
    BCollapse,
    KrActivity,
    ActionTooltip,
    CollapseCaret
  },
  data() {
    return {
      expanded: true
    }
  },
  computed: {
    ownerId() {
      let primaryOwnership = this.activity.goal.ownerships.find(ownership => ownership.isPrimary)
      return primaryOwnership ? primaryOwnership.userId : undefined
    }
  },
  methods: {
    hasActivity(activity) {
      return (
        activity.closedInitiativeEvents.length ||
        activity.initiativeStatusEvents.length ||
        activity.newInitiativeEvents.length ||
        activity.initiativeStatusEvents.length ||
        activity.checkinEvents.length ||
        activity.commentEvents.length ||
        activity.closeReopenEvents.length ||
        activity.initiativeCommentEvents.length ||
        activity.goalAwardEvents.length ||
        activity.initiativeAwardEvents.length
      )
    },
    goToGoalPage(event) {
      const goal = this.activity.goal
      const location = getGoalPageRouteConfig({
        orgId: goal.organizationId,
        goalId: goal.id
      })
      handleClickNavigation.call(this, event, location)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

.goal {
  padding: 8px 0 4px 0;
  cursor: pointer;

  &:hover .collapse-caret /deep/ .caret {
    opacity: 1;
  }
}

.goal-icon {
  margin-top: 4px;
}

.row-item {
  margin-left: 8px;
}
</style>
